import axios from 'axios';
import config from '../config';


const Add = async (batchId, userId, feeSchemeId) => {
    try {
        const data = new FormData();
        data.append("batchId", batchId);
        data.append("userId", userId);
        data.append("feeSchemeId", feeSchemeId);

        const token = localStorage.getItem("oojwt");
        const response = await axios.post(config.apiUrl + 'batchStudents/add/', data,
            {
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'multipart/form-data'
                }
            });
            
        if (response.status === 200) {
            return {
                status: 200,
                message: response.data.message,
                batchStudent: response.data.batchStudent
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 400,
            message: error.response.data.message
        };
    }
}


// get batch student payments by batchId, studentId with pagination
const GetBatchStudentPayments = async (batchId, studentId, page, limit) => {
    try {
        const token = localStorage.getItem("oojwt");
        const response = await axios.get(
            config.apiUrl + `batchStudents/payments/${batchId}/${studentId}`,
            {
                params: {
                    page,
                    limit
                },
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            }
        );

        if (response.status === 200) {
            return {
                status: 200,
                message: response.data.message,
                payments: response.data.payments || response.data.batchStudentPayments || [],
                totalPages: response.data.totalPages,
                currentPage: response.data.currentPage,
                totalRecords: response.data.totalRecords
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 400,
            message: error.response?.data?.message || "Something went wrong"
        };
    }
};

//get batches by studentId with pagination
const GetBatchesByStudentId = async (studentId, page, limit) => {
    try {
        const token = localStorage.getItem("oojwt");
        const response = await axios.get(
            config.apiUrl + `batchStudents/batches/${studentId}`,
            {
                params: {
                    page,
                    limit
                },
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            }
        );

        if (response.status === 200) {
            return {
                status: 200,
                message: response.data.message,
                mappedBatches: response.data.mappedBatches,
                totalPages: response.data.totalPages,
                currentPage: response.data.currentPage,
                totalRecords: response.data.totalRecords
            };
        }
    } catch (error) {
        console.log(error);
        return {
            status: 400,
            message: error.response?.data?.message || "Something went wrong"
        };
    }
};


export { Add, GetBatchStudentPayments, GetBatchesByStudentId};


